import React, { useState } from 'react';
import { Download, X } from 'lucide-react';
import { APK_URL, APK_NAME } from '../../utils/appDownload';

// "Install Android App" row + install steps, at the bottom of the App View menu (AppMoreSheet). Always shown; on an iPhone or inside
// the installed app the pop-up says why there is nothing to install.
const inApp = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || document.referrer.startsWith('android-app://');
const isIos = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

const STEPS = [
  'Tap "Download APK" below. If Android warns that the file may harm your device, tap "Download anyway".',
  'When the download finishes, tap the file in your notifications (or open Files > Downloads).',
  'If Android says installing is blocked, tap Settings, switch on "Allow from this source", then press Back.',
  'Tap Install, then Open.',
  `Sign in. ${APK_NAME} now opens like a normal app from your home screen.`,
];

export default function AppDownload() {
  const [open, setOpen] = useState(false);
  const note = isIos() ? 'This is an Android app, so it cannot be installed on an iPhone. Open this menu on an Android phone.'
    : inApp() ? 'You are already using the installed app. To install it on another Android phone, open this menu there.' : '';
  return (
    <>
      <button type="button" onClick={() => setOpen(true)}
        style={{ marginTop: 14, width: '100%', minHeight: 52, display: 'flex', alignItems: 'center', gap: 12, padding: '0 14px',
          background: 'var(--bg-card, #fff)', border: '1px solid var(--border)', borderRadius: 12, cursor: 'pointer',
          color: 'var(--text)', fontFamily: 'inherit', fontSize: '.92rem', fontWeight: 600, textAlign: 'left' }}>
        <span style={{ width: 32, height: 32, borderRadius: 8, background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--primary)' }}><Download size={17} /></span>
        <span style={{ flex: 1 }}>Install Android App</span>
      </button>
      {open && (
        <div onClick={() => setOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 18, padding: 22, width: '100%', maxWidth: 380, maxHeight: '90vh', overflowY: 'auto', position: 'relative' }}>
            <button type="button" aria-label="Close" onClick={() => setOpen(false)}
              style={{ position: 'absolute', top: 12, right: 12, background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280' }}>
              <X size={20} />
            </button>
            <h3 style={{ margin: '0 0 4px', fontSize: '1.1rem', fontWeight: 800, color: '#111827' }}>{APK_NAME} for Android</h3>
            <p style={{ margin: '0 0 14px', fontSize: '.82rem', color: '#6b7280' }}>How to install</p>
            {note && <p style={{ margin: '0 0 12px', padding: 10, borderRadius: 8, background: '#fef3c7', color: '#92400e', fontSize: '.82rem' }}>{note}</p>}
            <ol style={{ margin: 0, paddingLeft: 20, fontSize: '.86rem', color: '#374151', lineHeight: 1.6 }}>
              {STEPS.map(s => <li key={s} style={{ marginBottom: 6 }}>{s}</li>)}
            </ol>
            <a href={APK_URL} download className="btn btn-primary"
              style={{ marginTop: 14, width: '100%', display: 'flex', justifyContent: 'center', gap: 8, textDecoration: 'none' }}>
              <Download size={16} /> Download APK
            </a>
          </div>
        </div>
      )}
    </>
  );
}
